
export default function(){

  let token=localStorage.getItem("web_student_token");
  if(!token)
  {
return false

  }
return token 
}

export const do_student_login=(token)=>{
  localStorage.setItem("web_student_token",token)
}
